<template>
    <div>
        <div class="redisWarning-title">
        	<Breadcrumb>
                <BreadcrumbItem>{{this.$route.query.accountTypeName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.accountName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.cacheClusterId}}</BreadcrumbItem>
                <BreadcrumbItem to="/elasticache/redisMonitor">Redis</BreadcrumbItem>
                <BreadcrumbItem>
                    <a @click="ipAddress">{{ $t('alarms.common.alertRule') }}</a>
                </BreadcrumbItem>
            </Breadcrumb>
        </div>
        <template>
            <Tabs size="small" :animated="false">
                <TabPane :label="$t('alarms.common.alertRule')">
                    <div class="redisWarning-top">
                        <redis-warning-search></redis-warning-search>
                    </div>
                    <table-redis-warning></table-redis-warning>
                </TabPane>
            </Tabs>
        </template>
        
    </div>
</template>

<script>
    import RedisWarningSearch from '../redis/RedisWarningSearch'
    import TableRedisWarning from '../redis/TableRedisWarning'

    export default {
        name: 'RedisWarning',
        components: {
            RedisWarningSearch,
            TableRedisWarning
        },
        data(){
            return {
                id:'',
                accountId:'',
                accountTypeName:'',
                accountName:'',
                region:'',
                cacheClusterId:''
            }
        },
         methods:{
         	// 点击返回详情页
            ipAddress: function(){
                this.id = this.$route.query.id;
                this.accountId=this.$route.query.accountId;
                this.region=this.$route.query.region;
                this.accountTypeName=this.$route.query.accountTypeName;
                this.accountName=this.$route.query.accountName;
                this.cacheClusterId=this.$route.query.cacheClusterId;
                this.$router.push({path:'/elasticache/redisDetail/',query: {id: this.id,accountId:this.accountId,region:this.region,accountTypeName:this.accountTypeName,accountName:this.accountName,cacheClusterId:this.cacheClusterId}});
            }
        }
    }
</script>

<style scoped>
    .redisWarning-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .redisWarning-top
    {
        width: 100%;
        height: 32px;
        margin-bottom: 14px;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/elasticache/redis/RedisWarning.vue